import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ProfileIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 19" {...props}>
            <path
                d="M10 18C14.6944 18 18.5 14.1944 18.5 9.5C18.5 4.80558 14.6944 1 10 1C5.30558 1 1.5 4.80558 1.5 9.5C1.5 14.1944 5.30558 18 10 18Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.1717 16.0038V14.7109C15.1717 14.0251 14.8992 13.3673 14.4143 12.8824C13.9294 12.3975 13.2717 12.125 12.5859 12.125H7.4142C6.72839 12.125 6.07068 12.3975 5.58574 12.8824C5.1008 13.3673 4.82837 14.0251 4.82837 14.7109V16.0038"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0004 9.53921C11.4285 9.53921 12.5862 8.3815 12.5862 6.95338C12.5862 5.52527 11.4285 4.36755 10.0004 4.36755C8.57227 4.36755 7.41455 5.52527 7.41455 6.95338C7.41455 8.3815 8.57227 9.53921 10.0004 9.53921Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
